import values from 'lodash/fp/values';

import React from 'react';
import { FormattedMessage } from 'react-intl';

export const FATAL = 0;
export const ERROR = 1;
export const WARN = 2;
export const INFO = 3;
export const DEBUG = 4;
export const VERBOSE = 5;

export const CM4logLevelsEnum = [FATAL,ERROR,WARN,INFO,DEBUG,VERBOSE]

export const CM4LogLevelOptions = {
    [FATAL]: {
        id: `${FATAL}`,
        label: <FormattedMessage id='intl-msg:logLevel.fatal'/>,
        value: FATAL,
    },
    [ERROR]: {
        id: `${ERROR}`,
        label: <FormattedMessage id='intl-msg:logLevel.error'/>,
        value: ERROR,
    },
    [WARN]: {
        id: `${WARN}`,
        label: <FormattedMessage id='intl-msg:logLevel.warning'/>,
        value: WARN,
    },
    [INFO]: {
        id: `${INFO}`,
        label: <FormattedMessage id='intl-msg:logLevel.info'/>,
        value: INFO,
    },
    [DEBUG]: {
        id: `${DEBUG}`,
        label: <FormattedMessage id='intl-msg:logLevel.debug'/>,
        value: DEBUG,
    },

    [VERBOSE]: {
        id: `${VERBOSE}`,
        label: <FormattedMessage id='intl-msg:logLevel.verbose'/>,
        value: VERBOSE,
    },
};

export const createCM4LogLevelFilterOptions = () => values(CM4LogLevelOptions);
